/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';

import { ApplicationWideMessageComponent } from './components/application-wide-message.component';
import { GenericDialogModule } from '../generic-dialog/generic-dialog.module';
import { ForceRefreshDialogComponent } from './components/force-refresh-dialog/force-refresh-dialog.component';

@NgModule({
	declarations: [ApplicationWideMessageComponent, ForceRefreshDialogComponent],
	imports: [CommonModule, MaterialModule, GenericDialogModule],
	providers: [],
	exports: [ApplicationWideMessageComponent],
})
export class ApplicationWideMessageModule {}
export * from './services/application-wide-message.service';
